import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('plan_product', '/plan_products')
const reducer = generator.generate()

export default reducer
